import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import ERP from "../../../../../utils/ErpService";

export default function InvUnidadesForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.mdd_id);
  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    setCurId(record.mdd_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await ERP.sendMaestro(
      currentUser,
      curId,
      "InvUnidades",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE UNIDADES DE MEDIDA",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE UNIDADES DE MEDIDA",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="InvUnidades"
      onFinish={guardarCambios}
      initialValues={{
        mdd_codigo: record.mdd_id > 0 ? record.mdd_codigo : "",
        mdd_nombre: record.mdd_id > 0 ? record.mdd_nombre : "",
        mdd_piezas: record.mdd_id > 0 ? record.mdd_piezas : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.mdd_id > 0
            ? "ACTUALIZAR UNIDADES DE MEDIDA"
            : "AGREGAR UNIDADES DE MEDIDA"}
        </Title>
      </Form.Item>
      <Form.Item
        name="mdd_codigo"
        label="Codigo"
        rules={[
          {
            required: true,
            message: "El Codigo es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "100px" }}
          value={record.mdd_id > 0 ? record.mdd_codigo : ""}
        />
      </Form.Item>
      <Form.Item
        name="mdd_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.mdd_id > 0 ? record.mdd_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="mdd_piezas"
        label="Piezas"
        rules={[
          {
            required: true,
            message: "El numero de piezas es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "100px" }}
          value={record.mdd_id > 0 ? record.mdd_piezas : ""}
        />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
